module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cc0255360a4a80c094a9d454c8e734f4.png";